const formDataUtils = {
  build(formData, data, parentKey) {
    if (
      data &&
      typeof data === 'object' &&
      !(data instanceof Date) &&
      !(data instanceof File)
    ) {
      Object.keys(data).forEach((key) => {
        this.build(
          formData,
          data[key],
          parentKey ? `${parentKey}${isNaN(key) ? `.${key}` : `[${key}]`}` : key
        );
      });
    } else {
      const value = data == null ? '' : data;

      formData.append(parentKey, value);
    }
  },
};

export default formDataUtils;
